// extracted by mini-css-extract-plugin
export var banner = "_qx-0";
export var settingRow = "_qx-2";
export var titleIcon = "_qx-1";